import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { translate } from '@jsverse/transloco';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from 'app/app-shared.module';
import {
  AiInsightFeed,
  AiInsightsGroupFeedService,
} from 'app/providers/storage-api/ai-insights-group-feeds.service';
import { WidgetInsightFeedSource } from '../../widget-insight-feed/widget-insight-feed.component';

@Component({
  selector: 'app-widget-add-feed-options',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './widget-add-feed-options.component.html',
  styleUrl: './widget-add-feed-options.component.scss',
  host: {
    style: 'display: contents',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetAddFeedOptionsComponent implements OnInit {
  projectId = input<string>();
  feedSourceChanged = output<{ source: WidgetInsightFeedSource; query: string[] }>();

  selectedInsightFeedSource: WidgetInsightFeedSource | 'selectFeeds' = 'allProjectFeeds';
  insightFeedSourceOptions: DropdownObject[] = [];
  selectedInsightFeedSourceOptions: DropdownObject[] = [];
  insightFeeds: AiInsightFeed[];
  selectedInsightFeed: AiInsightFeed;

  private aiInsightsGroupFeedService = inject(AiInsightsGroupFeedService);

  ngOnInit(): void {
    this.buildInsightFeedSourceOptions();
    this.feedSourceChanged.emit({ source: 'allProjectFeeds', query: undefined });
    this.aiInsightsGroupFeedService
      .getAiInsightsGroupFeeds('allProjectFeeds', this.projectId())
      .then((result) => {
        this.insightFeeds = result.items;
        this.setInsightFeedDropdownState(this.insightFeeds);
      });
  }

  private setInsightFeedDropdownState(feeds: AiInsightFeed[]): void {
    const { options, selectedValue } =
      this.aiInsightsGroupFeedService.getInsightFeedDropdownState(feeds);

    this.selectedInsightFeedSourceOptions = options;
    this.selectedInsightFeed = this.insightFeeds.find((feed) => feed.id === selectedValue);
  }

  private buildInsightFeedSourceOptions(): void {
    this.insightFeedSourceOptions = [
      {
        id: 'allProjectFeeds',
        title: translate('widgets.widget-add.feed-options.all-project'),
      },
      {
        id: 'dashboardFeeds',
        title: translate('widgets.widget-add.feed-options.all-dashboard'),
      },
      {
        id: 'selectFeeds',
        title: translate('widgets.widget-add.feed-options.select-feeds'),
      },
    ];
  }

  onInsightFeedSourceChange(feedSourceOption: WidgetInsightFeedSource | 'selectFeeds') {
    const feedSource = feedSourceOption === 'selectFeeds' ? 'allProjectFeeds' : feedSourceOption;
    this.selectedInsightFeedSource = feedSourceOption;
    this.feedSourceChanged.emit({ source: feedSource, query: undefined });
  }

  onInsightFeedsChange(feeds: DropdownObject[]) {
    const feedQuery = feeds.map((feed: DropdownObject) => `id:${feed.id}`);
    this.feedSourceChanged.emit({ source: 'allProjectFeeds', query: feedQuery });
  }
}
